import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import {
	TTableStructure,
	ETableStructureType,
	ETableStructureAlign,
	TTableStructureButton,
} from 'ui/EasTable/types';
import {
	TEmEnumItem,
	TEmEnumsResponsePayload,
	TEmSiteItem,
} from 'redux/reducers/emManagement/types';

export const getTableStructure = (
	enumsSiteIntegrationType?: TEmEnumsResponsePayload,
	enumsSitePlatform?: TEmEnumsResponsePayload,
): TTableStructure<keyof (TEmSiteItem & { actions: string })>[] => [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Platform',
		selector: 'sitePlatform',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS_NO_BG,
		filter: enumsSitePlatform?.map((i: TEmEnumItem) => [i.value, i.displayName]) ?? [],
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'URL',
		selector: 'webAddress',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Integration',
		selector: 'integrationType',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		filter:
			enumsSiteIntegrationType?.map((i: TEmEnumItem) => [i.value, i.displayName.toLowerCase()]) ??
			[],
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Main',
		selector: 'mainSite',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [
			{ name: 'Edit', icon: EIconButtons.EDIT },
			{ name: 'Delete', icon: EIconButtons.DELETE, color: 'error.main' },
		],
		buttonFilter(item) {
			const buttons: TTableStructureButton[] = [];
			buttons.push({ name: 'Edit', icon: EIconButtons.EDIT });
			if (!item.mainSite) {
				buttons.push({ name: 'Delete', icon: EIconButtons.DELETE, color: 'error.main' });
			}
			return buttons;
		},
	},
];
